import { Property } from "./interfaces";

export const numConsultasCPrenatal: Property = {
    title: "Número de Consultas Cuidado Prenatal",
    type: "integer"
}